import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { User } from 'src/app/models/user.model';
import { MiniContactDisplayComponent } from 'src/app/features/users/components/mini-contact-display/mini-contact-display.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Recipient, RecipientsGroup } from 'src/app/models/recipients.model';
import { GroupDisplayComponent } from 'src/app/features/users/components/group-display/group-display.component';
import { GroupDisplayRecipientsComponent } from '../group-display-recipients/group-display-recipients.component';

@Component({
    selector: 'que-contact-tooltip',
    imports: [CommonModule, MiniContactDisplayComponent, TranslateDirective, TranslatePipe, GroupDisplayRecipientsComponent],
    templateUrl: './contact-tooltip.component.html',
    styleUrls: ['./contact-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactTooltipComponent implements OnInit {
  @Input() recipients?: Recipient[] = [];
  @Input() groups?: RecipientsGroup[] = [];
  @Input() title?: string;
  @Input() color: string = "#454352";
  @Input() isBottom = false;

  ngOnInit(): void {
  }
  stopClick(event: Event) {
    event.stopPropagation();
  }
}
